import normalize from './normalize'

const getChangedValues = (currentValues, defaultValues) => {
  const changedValues = {}

  Object.keys(currentValues).forEach((key) => {
    if (normalize(currentValues[key]) !== normalize(defaultValues[key])) {
      changedValues[key] = currentValues[key]
    }
  })

  return changedValues
}

export default getChangedValues
